import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';

type Player = {
  id: number;
  web_name: string;
  team_id: number;
  now_cost: number;
  form: number;
  eafd?: number;
};

export default function Players(): React.JSX.Element {
  const [players, setPlayers] = useState<Player[]>([]);
  const [q, setQ] = useState('');
  const [sort, setSort] = useState<'form' | 'now_cost' | 'eafd'>('form');

  useEffect(() => {
    const controller = new AbortController();
    async function load() {
      const res = await fetch('/api/bootstrap', { signal: controller.signal });
      const data = await res.json();
      const items: Player[] = (data.players ?? []).map((p: any) => ({
        id: p.id,
        web_name: p.web_name,
        team_id: p.team,
        now_cost: p.now_cost,
        form: Number(p.form ?? 0)
      }));
      setPlayers(items);
    }
    load();
    return () => controller.abort();
  }, []);

  const filtered = useMemo(() => {
    const term = q.trim().toLowerCase();
    let rows = players.filter(p => p.web_name.toLowerCase().includes(term));
    rows = rows.sort((a, b) => (Number(b[sort] ?? 0) - Number(a[sort] ?? 0)));
    return rows.slice(0, 200);
  }, [players, q, sort]);

  return (
    <div>
      <h2>Players</h2>
      <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
        <input placeholder="Search" value={q} onChange={e => setQ(e.target.value)} />
        <select value={sort} onChange={e => setSort(e.target.value as any)}>
          <option value="form">Form</option>
          <option value="now_cost">Price</option>
          <option value="eafd">EAFD</option>
        </select>
      </div>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th align="left">Name</th>
            <th align="right">Price</th>
            <th align="right">Form</th>
          </tr>
        </thead>
        <tbody>
          {filtered.map(p => (
            <tr key={p.id}>
              <td><Link to={`/player/${p.id}`}>{p.web_name}</Link></td>
              <td align="right">{(p.now_cost / 10).toFixed(1)}</td>
              <td align="right">{p.form.toFixed(1)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}



